import { Grid, Typography } from "@mui/material";
import { Card } from "components/ui";
import { usePermissions } from "context/PermissionsContext";
import { SettingContext } from "context/SettingContext";
import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetSyncList, useGetSyncListTotalCount } from "./apis/GetSyncListData";
import LoadingSmallCard from "components/ui/Skeleton/LoadingSmallCard";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import { actionTypeToName, actionTypeToRight } from "./utils/actionTypeToNameRight";
import { useGlobalContext } from "context/GlobalContext";

const SyncPage = () => {
  const { setSyncButton, search, setSearch, setSyncCount } = useContext(SettingContext);
  const { data, isLoading, error } = useGetSyncList({ search });
  const { data: totalData } = useGetSyncListTotalCount();
  const { setFilterChangeCount, setDisplayCount, setFilterChangeDesignCount } = useGlobalContext();

  const navigate = useNavigate();
  const location = useLocation();
  let preState = location.state;
  const permissions = usePermissions();

  const handleClick = (name, value) => {
    // const state = { ...preState, name: [preState?.name && preState?.name[0], `${actionTypeToName(name)} - ${value}`] };
    const state = { ...preState, name: [preState?.name && preState?.name[0], `${actionTypeToName(name)}`] };

    navigate(`/Setting/synchronize/${name}`, { state });
  };

  useEffect(() => {
    setSyncCount({
      cardCount: totalData?.cardCount,
      totalCount: totalData?.totalCount,
    });
    return () => {
      setSyncCount(null);
    };
  }, [totalData]);

  useEffect(() => {
    setFilterChangeCount(data?.cardCount);
    setFilterChangeDesignCount(data?.totalCount);
    setDisplayCount(true);
    return () => {
      setFilterChangeCount(0);
      setFilterChangeDesignCount(0);
      setDisplayCount(false);
    };
  }, [data]);

  useEffect(() => {
    setSyncButton(true);
    return () => {
      setSyncButton(false);
      setSearch("");
    };
  }, []);

  if (isLoading) return <LoadingSmallCard count={data?.length} />;

  if (error) return <div>Error:{error}</div>;

  return (
    <>
      <Grid
        container
        className="Grid-padding"
        direction="row"
        justifyContent="flex-start"
        sx={{ flex: "1 1 1", display: "flex", alignItems: "center", gap: "30px", rowGap: "32px", marginTop: "15px" }}
      >
        {data?.syncAllData?.map((el) => {
          const { actionType, count } = el;
          const findSyncSubpage =
           isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions),actionTypeToRight(actionType)), "view");
            // actionType == "set" || actionType == "collection" ? true : hasAccessSubPage(findSpecificSubPage(findSpecificPage("Sync", permissions), actionTypeToRight(actionType)), "view");
          if (!findSyncSubpage) {
            return null;
          }
          return (
            <Grid item onClick={() => handleClick(actionType, count)}>
              <Card style={{ minWidth: 275, maxWidth: "317px", height: 62, borderRadius: "5px" }}>
                <Typography mr={"auto"} fontSize={"20px"} fontWeight={400} fontFamily={"Karla"} sx={{ textTransform: "capitalize" }}>
                  {actionTypeToName(actionType)}
                </Typography>
                <Typography ml={"auto"} fontSize={"20px"} fontWeight={400} fontFamily={"Karla"}>
                  {count > 9 ? count : "0" + count}
                </Typography>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default SyncPage;
